import { writable, readable } from 'svelte/store';
import { getUrlParam } from '../helper/UIHelper';
// export const activeStep = writable(0);


export function get__store(store) {
    let $val
    store.subscribe($ => $val = $)()
    return $val
}

export const comesFromUrl = writable(getUrlParam('url') || getUrlParam('website') != null);

function createActiveStepStore() {
    let startingIndex = get__store(comesFromUrl) ? 5 : 0;
    if (startingIndex == 0 && getUrlParam('nourl') != null)
        startingIndex = 1;
    const { subscribe, set, update } = writable(startingIndex);
    return {
        subscribe,
        set,
        increment: () => {
            update(n => n + 1);
        },
        decrement: () => update(n => n - 1),
        reset: () => {
            set(null);
        }
    };
}

export const activeStep = createActiveStepStore();



function createActiveStepGroup() {
    const { subscribe, set, update } = writable(0);
    return {
        subscribe,
        set,
        increment: () => {
            update(n => n + 1);
        },
        decrement: () => update(n => n - 1),
        reset: () => {
            set(null);
        }
    };
}

export const activeGroup = createActiveStepGroup();

export const productFileId = writable(null);

export const showModal = writable(false);

export const showLoading = writable(false);
